import { createStore } from '@store/createStore';

const useOnboardStore = createStore(
  (set) => ({
    onBoardStepsCounter: 1,
    onBoardAiId: 0,
    onBoardStepIndex: 0,

    actions: {
      setUseOnboardStoreStepsCounter: (onBoardStepsCounter) => set({ onBoardStepsCounter }),
      setUseOnboardStoreAiId: (onBoardAiId) => set({ onBoardAiId }),
      setUseOnboardStoreStepIndex: (onBoardStepIndex) => set({ onBoardStepIndex }),
    },
  }),
  'OnboardStore',
);

export const useOnboardStoreActions = () => useOnboardStore((state) => state.actions);
export const selectUseOnboardStoreOnBoardAiId = () => useOnboardStore((state) => state.onBoardAiId);
export const selectUseOnboardStoreOnBoardStepsCounter = () =>
  useOnboardStore((state) => state.onBoardStepsCounter);
export const selectUseOnboardStoreOnBoardStepIndex = () => useOnboardStore((state) => state.onBoardStepIndex);
